export enum BulkUpdateInputItemType {
  NumberInput = 'NumberInput',
  TextInput = 'TextInput',
  TextArea = 'TextArea',
  SingleSelectDropdown = 'SingleSelectDropdown'
}